/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { addMinutes, format } from "date-fns";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as Yup from "yup";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import ViewButton from "components/standardized-components/ViewButton";

import DataTable from "examples/Tables/DataTable";

import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloseIcon from "@mui/icons-material/Close";

import {
  calculatePacketDetails,
  calculatePacketWeight,
  createAsn,
  createDynamicColumn,
  createPurchaseOrder,
  deletePurchaseOrder,
  editPurchaseOrder,
  getAcceptedPoClient,
  getAcceptedPoVendor,
  getAttechmentClient,
  getBinsForPrint,
  getDeliveryPlantForPO,
  getDynamicColumn,
  getItemMaster,
  getPackageType,
  getSubModulesByRoleId,
  getUnloadingPointForPO,
  getVendorCodes,
  getVendorInvoice,
  publishPo,
  publishPurchaseOrder,
  uploadForPurchaseOrderNew,
  uploadVendorInvoiceData,
} from "../../../store";

import Cookies from "universal-cookie";
import Config from "../../../config/index";
import "../../../store";

import { Backdrop, CircularProgress } from "@mui/material";
import DownloadButton from "components/standardized-components/DownloadButton";
import UploadButton from "components/standardized-components/UploadButton";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const modalBase = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};
const style = { ...modalBase, width: 350, boxShadow: 24, p: 0, pt: 3 };
const styleForCreatePo = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 500, lg: 900, xl: 900 },
  overflow: "auto",
  height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  boxShadow: 24,
  p: 1,
  pt: 3,
};
const deleteStyle = { ...modalBase, width: 350, boxShadow: 24, p: 2, pt: 3 };
const styleForRelease = {
  ...modalBase,
  width: 380,
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const styleForCreateASN = {
  ...modalBase,
  width: { xs: "80%", sm: "80%", md: "80%", lg: "90%", xl: "90%" },
  height: "fit-content",
  maxHight: "60%",
  overflow: "auto",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const AcceptPo = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  getAcceptedPoClient,
  getAcceptedPoVendor,

  createPurchaseOrder,
  editPurchaseOrder,
  deletePurchaseOrder,
  publishPurchaseOrder,
  uploadForPurchaseOrderNew,

  getVendorCodes,
  itemMaster,
  getItemMaster,
  getVendorCodeReducer,
  publishPo,
  getPackageType,
  packageTypeReducer,
  createAsn,
  calculatePacketDetails,
  packageDetailsReducer,
  getDeliveryPlantForPO,
  getUnloadingPointForPO,
  deliveryPlantForPOReducer,
  unloadingPointForPOReducer,
  calculatePacketWeight,
  packetWeightReducer,
  getBinsForPrint,
  binsForPrintReducer,
  acceptedPoClientReducer,
  acceptedPoVendorReducer,
  getAttechmentClient,
  getVendorInvoice,
  getVendorInvoiceReducer,
  uploadVendorInvoiceData,
  getDynamicColumn,
  createDynamicColumn,

  getDynamicColumnReducer,
}) => {
  const loginDetails = cookies.get("loginDetailsForWMS");
  const jwtToken = loginDetails?.jwt;
  const roleId = loginDetails?.data?.roleId;
  const userId = loginDetails?.data?.userId;
  const roleName = loginDetails?.data?.roleName;
  const email = loginDetails?.data?.email;

  const vendorRolePattern = /vendor/i;
  const isVendor = vendorRolePattern.test(roleName);

  let baseUrl = Config.baseUrl;

  useEffect(() => {
    if (roleId && jwtToken) getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId, jwtToken]);

  const [modulesData, setModulesData] = useState([]);
  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData?.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  // Screen access flags

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  const subModuleId = "f5662ed5-ad46-4dbc-80ee-309b0e190546";

  let purchaseOrderModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "f5662ed5-ad46-4dbc-80ee-309b0e190546",
  );

  let viewAccess = purchaseOrderModule
    ? purchaseOrderModule.actionId.includes(
        "855be5f7-d175-488e-8231-1446eb39e0fa",
      )
    : null;

  // for boath

  let viewInvoiceAccess = true;

  let uploadInvoiceAccess = isVendor;

  let downloadInvoiceAccess = purchaseOrderModule
    ? purchaseOrderModule.actionId.includes(
        "aee6bd9a-0b99-4bee-a13d-fc4bdaaa60d1",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) =>
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  const importRowsPerPage = (pageSize) => setRowsPerPage(pageSize);
  const importSearch = (globalFilter) =>
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");

  // Role-based fetch
  // const fetchPoList = () => {
  //   if (!jwtToken) return;
  //   if (
  //     roleName === "admin" ||
  //     roleName === "Admin" ||
  //     roleName === "spAdmin" ||
  //     roleName === "spadmin"
  //   ) {
  //     getAcceptedPoClient(pageNo, rowsPerPage, searchObject, jwtToken);
  //   } else {
  //     getAcceptedPoVendor(email, pageNo, rowsPerPage, searchObject, jwtToken);
  //   }
  // };
  const fetchPoList = () => {
    if (!jwtToken) return;
    isVendor
      ? getAcceptedPoVendor(email, pageNo, rowsPerPage, searchObject, jwtToken)
      : getAcceptedPoClient(pageNo, rowsPerPage, searchObject, jwtToken);
  };

  useEffect(() => {
    const t = setTimeout(() => {
      fetchPoList();
    }, 1000);
    return () => clearTimeout(t);
  }, [pageNo, rowsPerPage, searchObject, roleName, jwtToken]);

  // Vendor Upload state/handlers
  const [openVendorUploadModal, setOpenVendorUploadModal] = useState(false);
  const [vendorUploadPo, setVendorUploadPo] = useState(null);
  const [vendorFile, setVendorFile] = useState(null);
  const [purchaseOrderId, setPurchaseOrderId] = useState("");
  // const [invoiceNo, setInvoiceNo] = useState("");
  const [dueDate, setDueDate] = useState("");

  const [totalAmount, setTotalAmount] = useState("");
  const openVendorUpload = (po) => {
    setPurchaseOrderId(po.purchaseOrderId);
    setVendorUploadPo(po);
    setOpenVendorUploadModal(true);
  };
  const closeVendorUpload = () => {
    setOpenVendorUploadModal(false);
    setVendorUploadPo(null);
    setVendorFile(null);
    setPurchaseOrderId("");
    setDueDate("");
    setTotalAmount("");
    setInvoiceNo("");
  };
  // const submitVendorUpload = async () => {
  //   if (!vendorFile || !vendorUploadPo) return;
  //   const data = new FormData();
  //   data.append("purchaseOrderId", vendorUploadPo.purchaseOrderId);
  //   data.append("files" , vendorFile.files);
  //   try {
  //     const res = await uploadForPurchaseOrderNew(data, jwtToken);
  //     if (res?.status) {
  //       toast.success("File uploaded");
  //       fetchPoList();
  //       closeVendorUpload();
  //     } else {
  //       toast.error(res?.data?.data?.msg || "Upload failed");
  //     }
  //   } catch {
  //     toast.error("Upload failed");
  //   }
  // };
  // const submitVendorUpload = async () => {
  //   if (!vendorFile || !vendorUploadPo) return;
  //   const data = new FormData();
  //   data.append("purchaseOrderId", String(vendorUploadPo.purchaseOrderId));
  //   data.append("files", vendorFile, vendorFile.name);

  //   const InvoiceData = new FormData();
  //   InvoiceData.append("purchaseOrderId", String(purchaseOrderId));
  //   InvoiceData.append("invoiceNo", String(invoiceNo));
  //   InvoiceData.append("dueDate", String(dueDate));
  //   InvoiceData.append("totalAmount", String(totalAmount));

  //   try {
  //     const res = await uploadForPurchaseOrderNew(data, jwtToken);
  //     const res1 = await uploadVendorInvoiceData(InvoiceData, jwtToken);

  //     if (res?.status && res1?.status) {
  //       toast.success("File uploaded", {
  //         position: "top-center",
  //         autoClose: 2000,
  //       });
  //       fetchPoList();
  //       closeVendorUpload();
  //     } else {
  //       toast.error(res?.data?.data?.msg || "Upload failed", {
  //         position: "top-center",
  //         autoClose: 2000,
  //       });
  //     }
  //   } catch {
  //     toast.error("Upload failed", {
  //       position: "top-center",
  //       autoClose: 2000,
  //     });
  //   }
  // };

  const submitVendorUpload = async () => {
    if (!vendorFile || !vendorUploadPo) return;

    const data = new FormData();
    data.append("purchaseOrderId", String(vendorUploadPo.purchaseOrderId));
    data.append("files", vendorFile, vendorFile.name);

    const InvoiceData = {
      purchaseOrderId: String(purchaseOrderId),
      invoiceNo: String(invoiceNo),
      dueDate: String(dueDate),
      totalAmount: String(totalAmount),
    };

    try {
      const res = await uploadForPurchaseOrderNew(data, jwtToken);

      if (res?.status) {
        toast.success("Invoice file uploaded!", {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        toast.error(res?.data?.data?.msg || "Invoice file upload failed", {
          position: "top-center",
          autoClose: 2000,
        });
      }

      const res1 = await uploadVendorInvoiceData(InvoiceData, jwtToken);

      if (res1?.status) {
        toast.success("Invoice data uploaded!", {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        toast.error(res1?.data?.data?.msg || "Invoice data upload failed", {
          position: "top-center",
          autoClose: 2000,
        });
      }

      // Only if both succeeded, then move forward
      if (res?.status && res1?.status) {
        fetchPoList();
        closeVendorUpload();
      }
    } catch (error) {
      toast.error("Upload failed. " + (error?.message || ""), {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const [state, setState] = useState({
    columns: [
      { Header: "PO No.", accessor: "purchaseOrderNumber" },
      { Header: "PO LineNo.", accessor: "purchaseOrderLineNumber" },
      { Header: "Vendor Code", accessor: "vendorCode" },
      { Header: "Item code", accessor: "itemCode" },
      // { Header: "Item Description", accessor: "itemDescription" },
      { Header: "Po Date", accessor: "date" },
      { Header: "Qty", accessor: "qty" },
      { Header: "Unloading Point", accessor: "unloadingPoint" },
      { Header: "Delivery Plant", accessor: "deliveryPlant" },
      // { Header: "Status", accessor: "status" },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [asnQtyChange, setAsnQtyChange] = useState("");
  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [isErrorForCreateOrder, setIsErrorForCreateOrder] = useState(false);
  const [isSuccessForCreateOrder, setIsSuccessForCreateOrder] = useState(false);

  useEffect(() => {
    if (isErrorForCreateOrder) {
      const t = setTimeout(() => setIsErrorForCreateOrder(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isErrorForCreateOrder]);
  useEffect(() => {
    if (isSuccessForCreateOrder) {
      const t = setTimeout(() => setIsSuccessForCreateOrder(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isSuccessForCreateOrder]);

  const [isErrorRelease, setIsErrorRelease] = useState(false);
  const [isSuccessRelease, setIsSuccessRelease] = useState(false);
  useEffect(() => {
    if (isErrorRelease) {
      const t = setTimeout(() => setIsErrorRelease(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isErrorRelease]);
  useEffect(() => {
    if (isSuccessRelease) {
      const t = setTimeout(() => setIsSuccessRelease(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isSuccessRelease]);

  const [singleDataForRelease, setSingleDataForRelease] = useState({});
  const [openReleaseModal, setOpenReleaseModal] = useState(false);
  const handleOpenReleaseModal = (asset = {}) => {
    setSingleDataForRelease(asset);
    setOpenReleaseModal(true);
  };
  const handleCloseReleaseModal = () => setOpenReleaseModal(false);

  const [asnCode, setAsnCode] = useState("");
  const [packageType, setPackageType] = useState("");
  useEffect(() => {
    if (asnCode) getBinsForPrint(asnCode, jwtToken);
  }, [asnCode]);

  const [partCode, setPartCode] = useState("");
  const [purchaseOrderNumberOptions, setPurchaseOrderNumberOptions] = useState(
    [],
  );
  const [demandId, setDemandId] = useState("");

  useEffect(() => {
    if (partCode) getPackageType(partCode, jwtToken);
  }, [partCode]);
  useEffect(() => {
    if (partCode || asnQtyChange)
      calculatePacketWeight(partCode, asnQtyChange, jwtToken);
  }, [partCode, asnQtyChange]);

  useEffect(() => {
    if (demandId) getDeliveryPlantForPO(demandId, jwtToken);
  }, [demandId]);
  useEffect(() => {
    if (demandId) getUnloadingPointForPO(demandId, jwtToken);
  }, [demandId]);

  const [singleDeliveryPlantData, setSingleDeliveryPlantData] = useState("");
  const [singleUnloadingPointData, setSingleUnloadingPointData] = useState("");
  const [singleAsnPackageTypeData, setSingleAsnPackageTypeData] = useState("");
  const [singleAsnPackageWeightData, setSingleAsnPackageWeightData] =
    useState("");
  const [singleAsnPackageDetailsData, setSingleAsnPackageDetailsData] =
    useState({});

  useEffect(() => {
    const data = packageTypeReducer.packageTypeData?.data || [];
    setSingleAsnPackageTypeData(data?.packaging);
  }, [packageTypeReducer]);
  useEffect(() => {
    const data = packetWeightReducer.packetWeightData?.data || [];
    setSingleAsnPackageWeightData(data?.packWeight);
  }, [packetWeightReducer]);
  useEffect(() => {
    const data = deliveryPlantForPOReducer.deliveryPlantData?.data || [];
    setSingleDeliveryPlantData(data?.deliveryPlant);
  }, [deliveryPlantForPOReducer]);
  useEffect(() => {
    const data = unloadingPointForPOReducer.unloadingPointData?.data || [];
    setSingleUnloadingPointData(data?.unloadingPoint);
  }, [unloadingPointForPOReducer]);
  useEffect(() => {
    const data = packageDetailsReducer.packageDetailsData?.data || [];
    setSingleAsnPackageDetailsData(data);
  }, [packageDetailsReducer]);

  const [iframeLoading, setIframeLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
  const [attachmentUrl, setAttachmentUrl] = useState("");

  const onDownloadAttachment = async (purchase) => {
    try {
      const res = await getAttechmentClient(
        {
          file_name: purchase.poName,
          file_type: purchase.poType,
          purchaseOrderId: purchase.purchaseOrderId,
        },
        jwtToken,
      );

      if (res?.status && res?.url) {
        window.open(res.url, "_blank");
      } else {
        const errMsg = res?.msg || "Attachment not found";
        toast.error(errMsg, {
          position: "top-right",
          autoClose: 2000,
        });
      }
    } catch (err) {
      toast.error(`Attachment download failed: ${err.message}`, {
        position: "top-right",
        autoClose: 2000,
      });
    }
  };

  // const onViewVendorInvoice = async (purchase) => {
  //   try {
  //     const res = await getVendorInvoice(
  //       {
  //         file_name: purchase.invoiceName,
  //         file_type: purchase.invoiceType,
  //         purchaseOrderId: purchase.purchaseOrderId,
  //       },
  //       jwtToken
  //     );

  //     if (res?.status && res?.url) {
  //       setAttachmentUrl(res.url);
  //       setOpenAttachmentModal(true);
  //     } else {
  //       toast.error(res?.msg || "Invoice not found", {
  //         position: "top-right",
  //         autoClose: 2000,
  //       });
  //     }
  //   } catch (err) {
  //     console.error("Vendor invoice fetch error:", err);
  //     toast.error("Vendor invoice fetch failed", {
  //       position: "top-right",
  //       autoClose: 2000,
  //     });
  //   }
  // };
  const [isPDF, setIsPDF] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const onViewVendorInvoice = async (purchase) => {
    try {
      const res = await getVendorInvoice(
        {
          file_name: purchase.invoiceName,
          file_type: purchase.invoiceType,
          purchaseOrderId: purchase.purchaseOrderId,
        },
        jwtToken,
      );

      if (res?.status && res?.url) {
        let url = res.url;

        if (url && url.endsWith("pdf")) {
          url = `https://docs.google.com/gview?url=${encodeURIComponent(
            url,
          )}&embedded=true`;
          setIsPDF(true);
          setAttachmentUrl(url);
        } else if (
          url.endsWith("jpeg") ||
          url.endsWith("jpg") ||
          url.endsWith("png")
        ) {
          setIsPDF(false);
          setAttachmentUrl(url);
          setTimeout(() => {
            setIsLoading(false);
          }, 1000);
        }

        setOpenAttachmentModal(true);
      } else {
        toast.error("Invoice not found", {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (err) {
      // console.error("Vendor invoice fetch error:", err);
      toast.error("Vendor invoice fetch failed", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const onDownloadInvoice = async (purchase) => {
    try {
      const res = await getVendorInvoice(
        {
          file_name: purchase.invoiceName,
          file_type: purchase.invoiceType,
          purchaseOrderId: purchase.purchaseOrderId,
        },
        jwtToken,
      );

      if (res?.status && res?.url) {
        window.open(res.url, "_blank");
      } else {
        toast.error("Invoice not found", {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (err) {
      toast.error(`Invoice download failed: ${err.message}`, {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  // helpers

  useEffect(() => {
    // const tempAsset = [];
    // const slice =
    //   roleName === "admin" ||
    //   roleName === "Admin" ||
    //   roleName === "spAdmin" ||
    //   roleName === "spadmin"
    //     ? acceptedPoClientReducer
    //     : acceptedPoVendorReducer;
    // const payload =
    //   roleName === "admin" ||
    //   roleName === "Admin" ||
    //   roleName === "spAdmin" ||
    //   roleName === "spadmin"
    //     ? slice?.acceptedPoClient || {}
    //     : slice?.acceptedPoVendor || {};

    // const data = Array.isArray(payload?.data) ? payload.data : [];
    // const pagination = payload?.pagination || {};

    // setPaginationObj(pagination);
    // setLoading(!!slice?.loading);

    const tempAsset = [];
    const slice = isVendor ? acceptedPoVendorReducer : acceptedPoClientReducer;
    const payload = isVendor
      ? slice?.acceptedPoVendor || {}
      : slice?.acceptedPoClient || {};

    const data = Array.isArray(payload?.data) ? payload.data : [];
    const pagination = payload?.pagination || {};

    setPaginationObj(pagination);
    setLoading(!!slice?.loading);

    data.forEach((purchase) => {
      const formatDate = purchase?.date ? new Date(purchase.date) : null;

      const pdfUrl = purchase?.pdfFileUrl || purchase?.attachmentUrl || "";
      const hasAttachment = purchase?.poName && purchase?.poName !== "null";
      const vendorFileUrl =
        purchase?.invoiceName && purchase?.invoiceType !== "null";

      const row = {
        privateKey: purchase?.purchaseOrderId,
        purchaseOrderNumber: purchase?.purchaseOrderNumber,
        purchaseOrderLineNumber: purchase?.purchaseOrderLineNumber,
        vendorCode: purchase?.vendorCode,
        purchaseOrderId: purchase?.purchaseOrderId,
        itemCode: purchase?.itemCode,
        itemDescription: purchase?.itemDescription,
        isReleased: purchase?.isReleased,
        pdfFileUrl: pdfUrl,
        vendorAttachmentUrl: vendorFileUrl,
        date: formatDate
          ? format(
              addMinutes(formatDate, formatDate.getTimezoneOffset()),
              "do MMMM yyyy",
            )
          : "NA",
        qty: purchase?.qty,
        unloadingPoint:
          purchase?.unloadingPoint == (undefined || null || "undefined")
            ? "NA"
            : purchase?.unloadingPoint,
        deliveryPlant:
          purchase?.deliveryPlant == (undefined || null || "undefined")
            ? "NA"
            : purchase?.deliveryPlant,
        status: purchase?.isReleased === 0 ? "Not Released" : "Released",
        action: (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {viewInvoiceAccess && (
              <>
                {vendorFileUrl ? (
                  <>
                    <ViewButton
                      tooltip="View Invoice"
                      variant="gradient"
                      color="info"
                      iconOnly
                      type="button"
                      onClick={() => onViewVendorInvoice(purchase)}
                    >
                      <Icon>visibility</Icon>
                    </ViewButton>
                    {/* <ViewButton
                      tooltip="View Attachment"
                      variant="gradient"
                      color="primary"
                      iconOnly
                      type="button"
                      onClick={() => onViewAttachmentClient(purchase)}
                    >
                      <Icon>attachment</Icon>
                    </ViewButton> */}
                  </>
                ) : (
                  <>
                    <ViewButton
                      tooltip="No Invoice Available"
                      variant="gradient"
                      style={{
                        background: "grey",
                        color: "white",
                        opacity: 0.5,
                        borderRadius: 5,
                      }}
                      iconOnly
                      type="button"
                      // disabled
                    >
                      <Icon>visibility</Icon>
                    </ViewButton>

                    {/* <DownloadButton
                      tooltip="No PDF Available"
                      variant="gradient"
                      style={{
                        background: "grey",
                        color: "white",
                        opacity: 0.5,
                        borderRadius: "5px",
                      }}
                      iconOnly
                      type="button"
                      // disabled
                    >
                      <Icon>download</Icon>
                    </DownloadButton> */}
                  </>
                )}
              </>
            )}

            {/* {downloadInvoiceAccess && (
              <>
                {hasAttachment ? (
                  <>
                    <DownloadButton
                      tooltip="Download invoice"
                      variant="contained"
                      color="success"
                      iconOnly
                      type="button"
                      onClick={() => onDownloadInvoice(purchase)}
                    >
                      <Icon>download</Icon>
                    </DownloadButton>
                  </>
                ) : (
                  <>
                    <DownloadButton
                      tooltip="No invoice Available"
                      variant="gradient"
                      style={{
                        background: "grey",
                        color: "white",
                        opacity: 0.5,
                        borderRadius: "5px",
                      }}
                      iconOnly
                      type="button"
                      // disabled
                    >
                      <Icon>download</Icon>
                    </DownloadButton>
                  </>
                )}
              </>
            )} */}

            {/* {downloadInvoiceAccess && (
              <>
                {hasAttachment || vendorFileUrl ? (
                  <DownloadButton
                    tooltip={
                      roleName === "admin" ||
                      roleName === "Admin" ||
                      roleName === "spAdmin" ||
                      roleName === "spadmin"
                        ? "Download Invoice"
                        : "Download Attachment"
                    }
                    variant={
                      roleName === "admin" ||
                      roleName === "Admin" ||
                      roleName === "spAdmin" ||
                      roleName === "spadmin"
                        ? "contained"
                        : "gradient"
                    }
                    color={
                      roleName === "admin" ||
                      roleName === "Admin" ||
                      roleName === "spAdmin" ||
                      roleName === "spadmin"
                        ? "success"
                        : "primary"
                    }
                    iconOnly
                    type="button"
                    onClick={() => {
                      if (
                        roleName === "admin" ||
                        roleName === "Admin" ||
                        roleName === "spAdmin" ||
                        roleName === "spadmin"
                      ) {
                        onDownloadInvoice(purchase);
                      } else {
                        onDownloadAttachment(purchase);
                      }
                    }}
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                ) : (
                  <DownloadButton
                    tooltip={
                      roleName === "admin" ||
                      roleName === "Admin" ||
                      roleName === "spAdmin" ||
                      roleName === "spadmin"
                        ? "No Invoice Available"
                        : "No Attachment Available"
                    }
                    variant="gradient"
                    style={{
                      background: "grey",
                      color: "white",
                      opacity: 0.5,
                      borderRadius: "5px",
                    }}
                    iconOnly
                    type="button"
                    // disabled
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                )}
              </>
            )} */}

            {/* new updated user managment */}

            {/* {downloadInvoiceAccess && (
              <>
                {hasAttachment || vendorFileUrl ? (
                  <DownloadButton
                    tooltip={
                      isVendor ? "Download Attachment" : "Download Invoice"
                    }
                    variant={isVendor ? "gradient" : "contained"}
                    color={isVendor ? "primary" : "success"}
                    iconOnly
                    type="button"
                    onClick={() => {
                      isVendor
                        ? onDownloadAttachment(purchase)
                        : onDownloadInvoice(purchase);
                    }}
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                ) : (
                  <DownloadButton
                    tooltip={
                      isVendor
                        ? "No Attachment Available"
                        : "No Invoice Available"
                    }
                    variant="gradient"
                    style={{
                      background: "grey",
                      color: "white",
                      opacity: 0.5,
                      borderRadius: "5px",
                    }}
                    iconOnly
                    type="button"
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                )}
              </>
            )} */}

            {isVendor ? (
              hasAttachment || vendorFileUrl ? (
                // Vendor - Attachment Available
                <DownloadButton
                  tooltip="Download Attachment"
                  variant="gradient"
                  color="primary"
                  iconOnly
                  type="button"
                  onClick={() => onDownloadAttachment(purchase)}
                >
                  <Icon>download</Icon>
                </DownloadButton>
              ) : (
                // Vendor - No Attachment
                <DownloadButton
                  tooltip="No Attachment Available"
                  variant="gradient"
                  style={{
                    background: "grey",
                    color: "white",
                    opacity: 0.5,
                    borderRadius: "5px",
                  }}
                  iconOnly
                  type="button"
                  // disabled
                >
                  <Icon>download</Icon>
                </DownloadButton>
              )
            ) : null}

            {!isVendor &&
              (vendorFileUrl ? (
                // Non-Vendor - Invoice Available
                <DownloadButton
                  tooltip="Download Invoice"
                  variant="contained"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => onDownloadInvoice(purchase)}
                >
                  <Icon>download</Icon>
                </DownloadButton>
              ) : (
                // Non-Vendor - No Invoice
                <DownloadButton
                  tooltip="No Invoice Available"
                  variant="contained"
                  color="success"
                  style={{
                    background: "grey",
                    color: "white",
                    opacity: 0.5,
                    borderRadius: "5px",
                  }}
                  iconOnly
                  type="button"
                  // disabled
                >
                  <Icon>download</Icon>
                </DownloadButton>
              ))}

            {uploadInvoiceAccess && (
              <>
                <UploadButton
                  tooltip="Uploaded File"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => openVendorUpload(purchase)}
                >
                  <Icon>upload</Icon>
                </UploadButton>
              </>
            )}
          </div>
        ),
      };

      tempAsset.push(row);
    });

    setState((s) => ({ ...s, rows: tempAsset }));
  }, [acceptedPoClientReducer, acceptedPoVendorReducer, isVendor]);

  const [fileForTestCertificate, setFileForTestCertificate] = useState({});
  const handleChangeForTestCertificate = (event) =>
    setFileForTestCertificate(event.target.files);

  const [fileForInvoiceFile, setFileForInvoiceFile] = useState({});
  const handleChangeForInvoiceFile = (event) =>
    setFileForInvoiceFile(event.target.files);

  const [openCreateASNModal, setOpenCreateASNModal] = useState(false);
  const [singleASNData, setSingleASNData] = useState({});
  const handleOpenCreateASNModal = (ActualQty = {}) => {
    setSingleASNData(ActualQty);
    setOpenCreateASNModal(true);
    setIsErrorCreateASN(false);
    setIsSuccessCreateASN(false);
  };
  const handleCloseCreateASNModal = () => {
    setOpenCreateASNModal(false);
    formik.setValues(initialValues);
    formik.setTouched({});
    formik.setErrors({});
    setAsnQtyChange("");
    window.location.reload();
  };
  const AsnCreationNotification = () =>
    toast.success("Asn Created Successfully", {
      position: "top-center",
      autoClose: 2000,
    });
  const [createAsnError, setCreateAsnError] = useState("");
  const [isErrorCreateASN, setIsErrorCreateASN] = useState(false);
  const [isSuccessCreateASN, setIsSuccessCreateASN] = useState(false);
  useEffect(() => {
    if (isErrorCreateASN) {
      const t = setTimeout(() => setIsErrorCreateASN(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isErrorCreateASN]);
  useEffect(() => {
    if (isSuccessCreateASN) {
      const t = setTimeout(() => setIsSuccessCreateASN(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isSuccessCreateASN]);

  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");

  const initialValues = {
    demandId: singleASNData ? singleASNData.id : "",
    partNoDes: `${singleASNData ? singleASNData.itemCode : ""}/${
      singleASNData ? singleASNData.itemDescription : ""
    }`,
    poNoLineNo: `${singleASNData ? singleASNData.purchaseOrderNumber : ""}/${
      singleASNData ? singleASNData.purchaseOrderLineNumber : ""
    }`,
    scheduleQuantity: singleASNData ? singleASNData.qty : "",
    asnQty: asnQtyChange ? asnQtyChange : "",
    balanceQty: singleASNData ? singleASNData.balanceQty : "",
    unloadingPoint: singleUnloadingPointData ? singleUnloadingPointData : "",
    deliveryPlant: singleDeliveryPlantData ? singleDeliveryPlantData : "",
    packageType: singleAsnPackageTypeData ? singleAsnPackageTypeData : "",
    packetNo: "",
    packetWeight: "",
    invoiceNo: singleASNData ? singleASNData.invoiceNo : "",
    invoiceDate: singleASNData ? singleASNData.invoiceDate : "",
    planDate: "",
  };

  const validationSchema = Yup.object({
    asnQty: Yup.number()
      .min(1)
      .max(singleASNData.balanceQty)
      .required("Enter a valid ASN quantity"),
  });

  const [buttonNameForCreateAsn, setButtonNameForCreateAsn] =
    useState("Create ASN");
  const onSubmit = async (values, { resetForm }) => {
    setButtonNameForCreateAsn("Please wait...");
    let payload = {
      poNoLineNo: values.poNoLineNo,
      testCertificate: fileForTestCertificate,
      invoice: fileForInvoiceFile,
      asnDetails: JSON.stringify([
        {
          invoiceDate: invoiceDate,
          planDate: singleASNData ? singleASNData.date : "",
          itemCodeDes: values.partNoDes,
          invoiceNo: invoiceNo,
          asnQty: values.asnQty,
          packageType: singleAsnPackageTypeData,
          packetNo: singleAsnPackageDetailsData.packetQty,
          packetWeight: singleAsnPackageWeightData,
          unloadingPoint: singleUnloadingPointData,
          deliveryPlant: singleDeliveryPlantData,
          demandId: singleASNData ? singleASNData.demandId : "",
        },
      ]),
      vendorId: userId,
    };

    let response = await createAsn(payload, jwtToken);

    if (response.status === true) {
      setAsnCode(response.data.data.asnCode);
      setPackageType(response.data.data.packageType);
      setIsSuccessCreateASN(true);
      AsnCreationNotification();
      setTimeout(() => {
        setButtonNameForCreateAsn("Create ASN");
      }, 2250);
      fetchPoList();
      resetForm();
    }
    if (response.status === false) {
      setIsErrorCreateASN(true);
      setButtonNameForCreateAsn("Create ASN");
      setCreateAsnError(response?.data?.data?.msg);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
  });

  const [openPrintASNModal, setOpenPrintASNModal] = useState(false);
  const handleClosePrintASNModal = () => setOpenPrintASNModal(false);
  const handleOpenPrintASNModal = () => setOpenPrintASNModal(true);

  let typeOptions = [
    { label: "Bin", value: "bin" },
    { label: "Pallet", value: "pallet" },
  ];

  const [openCreatePoModal, setOpenCreatePoModal] = useState(false);
  const handleOpenCreatePoModal = () => {
    setOpenCreatePoModal(true);
    formikForCreatePo.setValues(initialValueForCreatePo);
    formikForCreatePo.setTouched({});
    formikForCreatePo.setErrors({});
    setSelectedItemCode("");
    setSelectedVendorCode("");
    getVendorCodes(jwtToken);
    getItemMaster(jwtToken);
  };
  const handleCloseCreateProductionModal = () => setOpenCreatePoModal(false);

  const initialValueForCreatePo = {
    poDate: "",
    vendorCode: "",
    itemCode: "",
    poNo: "",
    poLineNo: "",
    reqQty: "",
  };
  const today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();
  let currentDate = yyyy + "-" + mm + "-" + dd;
  today.setHours(0, 0, 0, 0);
  const todayStr = today.toISOString().split("T");

  const validationSchemaForPo = Yup.object({
    poDate: Yup.date().min(today, "Date cannot be in the past!"),
    poNo: Yup.string().required("Enter PO No."),
    vendorCode: Yup.object().required("Select Vendor Code"),
    itemCode: Yup.object().required("Select Item Code"),
    poLineNo: Yup.string().required("Enter PO Line No."),
    reqQty: Yup.string().required("Enter a qty"),
    unloadingPoint: Yup.string().required("Enter unloading point"),
    deliveryPlant: Yup.string().required("Enter delivery plant"),
  });

  const onSubmitForCreatePo = async (values, { resetForm }) => {
    let payload = {
      purchaseOrderNumber: values.poNo,
      purchaseOrderLineNumber: values.poLineNo,
      itemCode: selectedItemCode?.itemCode,
      itemId: selectedItemCode?.value,
      date: values.poDate,
      qty: values.reqQty,
      unloadingPoint: values.unloadingPoint.trim(),
      deliveryPlant: values.deliveryPlant.trim(),
      userId: userId,
      vendorCode: selectedVendorCode?.value,
    };

    let res = await createPurchaseOrder(payload, jwtToken);

    if (res.status) {
      setIsSuccessForCreateOrder(true);
      fetchPoList();
      setSelectedItemCode("");
      setSelectedVendorCode("");
      setTimeout(() => {
        handleCloseCreateProductionModal();
      }, 2000);
      resetForm();
    }
    if (!res.status) {
      setIsErrorForCreateOrder(true);
      setErrorMsgForCreate(res?.data?.data?.msg);
    }
  };

  const formikForCreatePo = useFormik({
    initialValues: initialValueForCreatePo,
    validationSchema: validationSchemaForPo,
    onSubmit: onSubmitForCreatePo,
  });

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [
    singlePurchaseOrderDataForDelete,
    setSinglePurchaseOrderDataForDelete,
  ] = useState({});
  const handleOpenDeleteModal = (asset = {}) => {
    setSinglePurchaseOrderDataForDelete(asset);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);

  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [isSuccessDelete, setIsSuccessDelete] = useState(false);
  useEffect(() => {
    if (isErrorDelete) {
      const t = setTimeout(() => setIsErrorDelete(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isErrorDelete]);
  useEffect(() => {
    if (isSuccessDelete) {
      const t = setTimeout(() => setIsSuccessDelete(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isSuccessDelete]);

  const deletePurchaseOrderData = async () => {
    let purchaseOrderId = Number(
      singlePurchaseOrderDataForDelete.purchaseOrderId,
    );
    let res = await deletePurchaseOrder(purchaseOrderId, userId, jwtToken);
    if (res.status) {
      setIsSuccessDelete(true);
      fetchPoList();
    }
    if (!res.status) {
      setIsErrorDelete(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
    }
  };

  const [isErrorMsgForRelease, setIsErrorMsgForRelease] = useState(false);
  const [isSuccessMsgForRelease, setIsSuccessMsgForRelease] = useState(false);

  const [openUpdatePurchaseOrderModal, setOpenUpdatePurchaseOrderModal] =
    useState(false);
  const [singlePurchaseOrderDataForUpdate, setPurchaseOrderDataForUpdate] =
    useState({});

  const handleOpenUpdatePurchaseOrderModal = (Asset = {}) => {
    setPurchaseOrderDataForUpdate(Asset);
    setOpenUpdatePurchaseOrderModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateProductionModal = () => {
    setOpenUpdatePurchaseOrderModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  useEffect(() => {
    if (isErrorForUpdate) {
      const t = setTimeout(() => setIsErrorForUpdate(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isErrorForUpdate]);
  useEffect(() => {
    if (isSuccessForUpdate) {
      const t = setTimeout(() => setIsSuccessForUpdate(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    reqQty: singlePurchaseOrderDataForUpdate.qty,
    eDate: singlePurchaseOrderDataForUpdate.date?.slice(0, 10),
  };

  const [selectedItemCode, setSelectedItemCode] = useState("");
  const handleItemCodeChange = (selectedItemCode) =>
    setSelectedItemCode(selectedItemCode);
  const [itemCodeOptions, setItemCodeOptions] = useState([]);
  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
        itemCode: item.itemCode,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [selectedVendorCode, setSelectedVendorCode] = useState("");
  const handleVendorCodeChange = (selectedItemCode) =>
    setSelectedVendorCode(selectedItemCode);
  const [vendorCodeOptions, setVendorCodeOptions] = useState([]);
  useEffect(() => {
    let tempVendorCodeOptions = [];
    let data = getVendorCodeReducer.vendors.data
      ? getVendorCodeReducer.vendors.data
      : [];
    data.map((item) => {
      tempVendorCodeOptions.push({
        label: item.vendorName,
        value: item.vendorCode,
      });
    });
    setVendorCodeOptions(tempVendorCodeOptions);
  }, [getVendorCodeReducer]);

  const onSubmitForUpdate = async (values) => {
    let payload = {
      purchaseOrderId: singlePurchaseOrderDataForUpdate.purchaseOrderId,
      qty: values.reqQty,
      date: values.eDate,
      userId: userId,
    };
    let res = await editPurchaseOrder(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      fetchPoList();
      setTimeout(() => {
        handleCloseUpdateProductionModal();
      }, 2000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
    }
  };
  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });
  const DataUploadFailureNotification = (data) =>
    toast.error(data, { position: "top-center", autoClose: 2000 });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const uploadCsvFilterHandler = () => setUploadCsvFilter(!uploadCsvFilter);
  const [uploadCsvData, setUploadCsvData] = useState({});
  const uploadCsvHandler = async () => {
    let data = new FormData();
    data.append("userId", userId);
    data.append("purchase", uploadCsvData);
    let res = await uploadForPurchaseOrderNew(data, jwtToken);
    if (res.status) {
      fetchPoList();
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const headers = [
    { label: "purchaseOrderNumber", key: "purchaseOrderNumber" },
    { label: "purchaseOrderLineNumber", key: "purchaseOrderLineNumber" },
    { label: "vendorCode", key: "vendorCode" },
    { label: "itemCode", key: "itemCode" },
    { label: "date", key: "date" },
    { label: "qty", key: "qty" },
    { label: "unloadingPoint", key: "unloadingPoint" },
    { label: "deliveryPlant", key: "deliveryPlant" },
  ];
  const csvLink = {
    filename: "Purchase Order.csv",
    headers: headers,
    data: rows,
  };
  const csvLink2 = {
    filename: "Purchase Order Template.csv",
    headers: headers,
    data: [],
  };

  const [openCreatePublishModal, setOpenCreatePublishModal] = useState(false);
  const handleOpenCreatePublishModal = (data = {}) =>
    setOpenCreatePublishModal(true);
  const createPublishHandler = (event, data) =>
    handleOpenCreatePublishModal(data);

  const [openCreateReleaseModal, setOpenCreateReleaseModal] = useState(false);
  const handleOpenCreateReleaseModal = (data = {}) =>
    setOpenCreateReleaseModal(true);
  const handleCloseCreateReleaseModal = () => setOpenCreateReleaseModal(false);
  const createReleaseHandler = (event, data) =>
    handleOpenCreateReleaseModal(data);

  const [uncheck, setUncheck] = useState(false);
  const [selectedReleaseData, setSelectedReleaseData] = useState([]);
  const ReleaseForData = (data) => setSelectedReleaseData(data);

  const onClickCreateReleaseList = async () => {
    let tempArray = [];
    selectedReleaseData.map((data) => {
      const tempPayload = { purchaseOrderId: data.purchaseOrderId };
      tempArray.push(tempPayload);
    });

    let payload = { userId: userId, purchaseOrderIds: tempArray };
    let res = await publishPurchaseOrder(payload, jwtToken);

    if (res.status) {
      setUncheck(!uncheck);
      setIsSuccessRelease(true);
      fetchPoList();
      setTimeout(() => {
        handleCloseCreateReleaseModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorRelease(true);
      setIsErrorMsgForRelease(res?.data?.data?.msg);
    }
  };

  const [disableButton, setDisableButton] = useState(false);
  useEffect(() => {
    let value = selectedReleaseData.some((data) => data.isReleased === 1);
    setDisableButton(value);
  }, [selectedReleaseData]);

  const [isErrorPublish, setIsErrorPublish] = useState(false);
  const [isSuccessPublish, setIsSuccessPublish] = useState(false);
  useEffect(() => {
    if (isErrorPublish) {
      const t = setTimeout(() => setIsErrorPublish(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isErrorPublish]);
  useEffect(() => {
    if (isSuccessPublish) {
      const t = setTimeout(() => setIsSuccessPublish(false), 3000);
      return () => clearTimeout(t);
    }
  }, [isSuccessPublish]);

  const [isErrorMsgForPublish, setIsErrorMsgForPublish] = useState(false);
  const [singlePublishData, setSinglePublishData] = useState({});
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const handleOpenPublishModal = (asset = {}) => {
    setSinglePublishData(asset);
    setOpenPublishModal(true);
  };
  const handleClosePublishModal = () => setOpenPublishModal(false);

  const publishData = async () => {
    let payload = [{ purchaseOrderId: singlePublishData.purchaseOrderId }];
    let response = await publishPo(payload, jwtToken);
    if (response.status) {
      setIsSuccessPublish(true);
      fetchPoList();
      setTimeout(() => {
        handleClosePublishModal();
      }, 2250);
    }
    if (!response.status) {
      setIsErrorPublish(true);
      setIsErrorMsgForPublish(response?.data?.data?.msg);
    }
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getAcceptedPoClient(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={3}
              >
                <MDBox color="text" px={2} ml={2} mb={1}></MDBox>
              </MDBox>

              <MDBox mt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  options={{ draggable: false }}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                  disableButton={disableButton}
                />
              </MDBox>

              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* <Modal open={openVendorUploadModal} onClose={closeVendorUpload}>
                <MDCard sx={deleteStyle}>
                  <MDTypography>Upload Invoice</MDTypography>

                  <MDBox mt={2}>
                    <input
                      type="file"
                      name="files"
                      accept=".pdf,.png,.jpg,.jpeg"
                      onChange={(e) =>
                        setVendorFile(e.currentTarget.files[0] || null)
                      }
                    />
                  </MDBox>
                  <MDBox mt={2} display="flex">
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={closeVendorUpload}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={submitVendorUpload}
                      disabled={!vendorFile}
                    >
                      Upload
                    </MDButton>
                  </MDBox>
                </MDCard>
              </Modal> */}

              {/* <Modal open={openVendorUploadModal} onClose={closeVendorUpload}>
                <MDCard sx={deleteStyle}>
                  <MDTypography>Upload Invoice</MDTypography>

                  <MDBox
                    mt={2}
                    mb={1}
                    display="flex"
                    flexDirection="column"
                    gap={2}
                  >
                    <MDInput
                      label="Purchase Order ID"
                      value={purchaseOrderId}
                      disabled
                      fullWidth
                    />
                    <MDInput
                      label="Invoice No"
                      value={invoiceNo}
                      onChange={(e) => setInvoiceNo(e.target.value)}
                      required
                      fullWidth
                    />
                    <MDInput
                      type="date"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                      required
                      fullWidth
                      inputProps={{
                        min: new Date().toISOString().split("T")[0],
                      }}
                    />

                    <MDInput
                      label="Total Amount"
                      type="number"
                      value={totalAmount}
                      min="0"
                      onChange={(e) => setTotalAmount(e.target.value)}
                      required
                      fullWidth
                    />
                    <MDBox mt={2}>
                      
                      <input
                        type="file"
                        name="files"
                        accept=".pdf,.png,.jpg,.jpeg"
                        onChange={(e) =>
                          setVendorFile(e.currentTarget.files[0] || null)
                        }
                      />
                    </MDBox>
                  </MDBox>
                  <MDBox mt={2} display="flex">
                    <MDButton
                      style={{ width: "100%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={closeVendorUpload}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "100%", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={submitVendorUpload}
                      disabled={
                        !purchaseOrderId ||
                        !vendorFile ||
                        !invoiceNo ||
                        !dueDate ||
                        !totalAmount
                      }
                    >
                      Upload
                    </MDButton>
                  </MDBox>
                </MDCard>
              </Modal> */}
              <Modal
                open={openVendorUploadModal}
                onClose={closeVendorUpload}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard
                  sx={{
                    ...deleteStyle,
                    width: { xs: "70vw", sm: "60vw", md: "50vw", lg: "40vw" },
                    maxWidth: "800px",
                  }}
                >
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography
                      id="modal-modal-title"
                      variant="h4"
                      fontWeight="medium"
                      flexGrow={1}
                    >
                      Upload Invoice
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={closeVendorUpload}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>

                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox role="form" component="form">
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              PO ID
                            </MDTypography>
                            <MDInput
                              fullWidth
                              value={purchaseOrderId}
                              disabled
                              aria-readonly
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Invoice No
                            </MDTypography>
                            <MDInput
                              placeholder="Enter Invoice No"
                              fullWidth
                              value={invoiceNo}
                              onChange={(e) => setInvoiceNo(e.target.value)}
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Due Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              fullWidth
                              value={dueDate}
                              onChange={(e) => setDueDate(e.target.value)}
                              inputProps={{
                                min: new Date().toISOString().split("T")[0],
                              }}
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Total Amount
                            </MDTypography>
                            <MDInput
                              type="number"
                              fullWidth
                              value={totalAmount}
                              onChange={(e) => setTotalAmount(e.target.value)}
                              inputProps={{ min: 0, step: "0.01" }}
                            />
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Attachment
                            </MDTypography>
                            <input
                              type="file"
                              name="files"
                              accept=".pdf,.png,.jpg,.jpeg"
                              onChange={(e) =>
                                setVendorFile(
                                  e.currentTarget.files?.[0] || null,
                                )
                              }
                            />
                            {/* If you add validation later, keep helper like TextError here */}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <MDBox mt={2} display="flex">
                            <MDButton
                              style={{ width: "100%", marginRight: "0.5rem" }}
                              color="info"
                              variant="outlined"
                              onClick={closeVendorUpload}
                            >
                              Cancel
                            </MDButton>
                            <MDButton
                              style={{ width: "100%", marginLeft: "0.5rem" }}
                              color="success"
                              onClick={submitVendorUpload}
                              disabled={
                                !purchaseOrderId ||
                                !vendorFile ||
                                !invoiceNo ||
                                !dueDate ||
                                !totalAmount
                              }
                            >
                              Upload
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* // Attachment Preview Modal */}
              <Modal
                open={openAttachmentModal}
                onClose={() => setOpenAttachmentModal(false)}
                aria-labelledby="modal-attachment-title"
                aria-describedby="modal-attachment-desc"
              >
                <MDCard sx={styleForCreatePo}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Preview
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={() => setOpenAttachmentModal(false)}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginLeft: "-55px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />
                  <MDBox pt={1} pb={3} px={3} style={{ height: "100%" }}>
                    {attachmentUrl ? (
                      isPDF ? (
                        <iframe
                          title="PDF Preview"
                          src={attachmentUrl}
                          style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                          }}
                        />
                      ) : (
                        <img
                          src={attachmentUrl}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      )
                    ) : (
                      <MDTypography>No preview.</MDTypography>
                    )}
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    profileData: state.profile,
    itemMaster: state.itemMaster,
    getVendorCodeReducer: state.getVendorCodeReducer,
    packageTypeReducer: state.packageTypeReducer,
    packageDetailsReducer: state.packageDetailsReducer,
    deliveryPlantForPOReducer: state.deliveryPlantForPOReducer,
    unloadingPointForPOReducer: state.unloadingPointForPOReducer,
    packetWeightReducer: state.packetWeightReducer,
    binsForPrintReducer: state.binsForPrintReducer,

    acceptedPoClientReducer: state.acceptedPoClientReducer,
    acceptedPoVendorReducer: state.acceptedPoVendorReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),

    getAcceptedPoClient: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getAcceptedPoClient(pageNo, rowsPerPage, searchObject, jwtToken),
      ),

    getAcceptedPoVendor: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getAcceptedPoVendor(pageNo, rowsPerPage, searchObject, jwtToken),
      ),

    getVendorCodes: (jwtToken) => dispatch(getVendorCodes(jwtToken)),

    deletePurchaseOrder: (purchaseOrderId, userId, jwtToken) =>
      dispatch(deletePurchaseOrder(purchaseOrderId, userId, jwtToken)),

    publishPurchaseOrder: (payload, jwtToken) =>
      dispatch(publishPurchaseOrder(payload, jwtToken)),

    createPurchaseOrder: (payload, jwtToken) =>
      dispatch(createPurchaseOrder(payload, jwtToken)),

    editPurchaseOrder: (payload, jwtToken) =>
      dispatch(editPurchaseOrder(payload, jwtToken)),

    uploadForPurchaseOrderNew: (payload, jwtToken) =>
      dispatch(uploadForPurchaseOrderNew(payload, jwtToken)),

    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),

    publishPo: (payload, jwtToken) => dispatch(publishPo(payload, jwtToken)),

    getBinsForPrint: (asnCode, jwtToken) =>
      dispatch(getBinsForPrint(asnCode, jwtToken)),

    getPackageType: (partCode, jwtToken) =>
      dispatch(getPackageType(partCode, jwtToken)),

    calculatePacketWeight: (partCode, asnQtyChange, jwtToken) =>
      dispatch(calculatePacketWeight(partCode, asnQtyChange, jwtToken)),

    getUnloadingPointForPO: (id, jwtToken) =>
      dispatch(getUnloadingPointForPO(id, jwtToken)),

    getDeliveryPlantForPO: (id, jwtToken) =>
      dispatch(getDeliveryPlantForPO(id, jwtToken)),

    createAsn: (payload, jwtToken) => dispatch(createAsn(payload, jwtToken)),

    calculatePacketDetails: (asnQty, partCode, userId, jwtToken) =>
      dispatch(calculatePacketDetails(asnQty, partCode, userId, jwtToken)),

    getAttechmentClient: (purchaseOrderId, jwtToken) =>
      dispatch(getAttechmentClient(purchaseOrderId, jwtToken)),
    getVendorInvoice: (file_name, file_type, purchaseOrderId, jwtToken) =>
      dispatch(
        getVendorInvoice(file_name, file_type, purchaseOrderId, jwtToken),
      ),
    uploadVendorInvoiceData: (InvoiceData, jwtToken) =>
      dispatch(uploadVendorInvoiceData(InvoiceData, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AcceptPo);
